import React, {useState, useEffect} from 'react'
import { TextField, Button, FormControlLabel, Checkbox, Snackbar, InputAdornment, IconButton } from '@material-ui/core'
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import DoneIcon from '@material-ui/icons/Done'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import firebase from '../Services/firebase'
import MuiAlert from '@material-ui/lab/Alert'
import { useHistory } from 'react-router-dom'
import userService from '../Services/user'
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}


function Create() {
    var history = useHistory()
    const [roomName, setRoomName] = useState("")
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")

    const [validationError, setValidationError] = useState("")
    const [isPasswordProtected, setIsPasswordProtected] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [checkedRoomName, setCheckedRoomName] = useState(false)

    const [open, setOpen] = useState(false)
    const [cLoader, setCLoader]= useState(false)

    useEffect(()=>{
        
        var roomRef = firebase.database().ref("/rooms/"+roomName)

        roomRef.on('value', function(snapshot) {
            console.log(snapshot.val())
            if(snapshot.val() === null){
                setCheckedRoomName(true)
            } else{
                setCheckedRoomName(false)
            }
        })
    }, [roomName])

    const handleChange = ()=>{
        setIsPasswordProtected(!isPasswordProtected)
    }

    const handleClickError = () => {
        setOpen(true)
    }

    const handleCloseError = (event, reason) => {
        if(reason === 'clickaway'){return}
        setOpen(false)
    }

    const handleClickShowPassword = () => setShowPassword(!showPassword)
    const handleMouseDownPassword = () => setShowPassword(!showPassword)


    const checkRoomName = ()=>{
        if(!checkedRoomName){
            setCheckedRoomName(true)
        }
    }


    const validate = ()=>{
        if(isPasswordProtected){
            if(!password){
                setValidationError("Password can not be empty*")
                handleClickError()
                return false
            }
        }
        if(!checkedRoomName){
            setValidationError("Please Verify room name")
            handleClickError()
            return false
        }
        if(!roomName){
            setValidationError("Room name can not be empty")
            handleClickError()
            return false
        }
        return true
    }

    const submitCreate = ()=>{
        
        if(validate()){
            setCLoader(true)  
            var newUser = userService.join(roomName, password, userName)
            const data = {
                roomName: roomName,
                admin : newUser,
                password: password,
                
            }

            var roomRef = firebase.database().ref("/rooms/" + data.roomName)
            var roomRef2 = firebase.database().ref("/rooms/" + data.roomName + "/people")

            roomRef.set(data)
            .then(()=>{

                roomRef2.child(newUser.userUID).set(newUser).then((data4)=>{
                        console.log("New Person added")
                })
                console.log("Data Created")
                setCLoader(false)
                history.push('/room?name='+data.roomName)
            })
            .catch(function(error) {
                console.error("Error Creating Room: ", error)
            });
        }

        

        // firebase.firestore().collection("rooms").doc(data.roomName).set(data)
        // .then(function() {
        //     console.log("Document successfully written!");
        //     setCLoader(false)
        //     history.push('/room?name='+data.roomName)
        // })
        // .catch(function(error) {
        //     console.error("Error writing document: ", error);
        // });
    }

    return (
        <div>
            
            <div>
                <div style={{marginTop: '10px', paddingTop:'10px'}}>
                    <div style={{display:'flex', flexDirection: 'column', margin: '5px'}}>
                        <TextField
                            style={{margin:'10px'}}
                            required
                            id="outlined-required"
                            label="New Room Name"
                            value={roomName}
                            variant="outlined"
                            onChange={(e)=>{setRoomName(e.target.value)}}
                            InputProps={{ 
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {checkedRoomName ? <DoneOutlineIcon color="primary" /> : <DoneIcon />}
                                    </InputAdornment>
                                )
                            }}
                        />

                        <TextField
                            style={{margin:'10px'}}
                            id="outlined-required"
                            label="Your Name"
                            value={userName}
                            variant="outlined"
                            onChange={(e)=>{setUserName(e.target.value)}}
                        />

                        <div style={{textAlign:'left', margin: '10px'}}>
                            <FormControlLabel
                                value={isPasswordProtected}
                                control={
                                <Checkbox color="primary" checked={isPasswordProtected} onChange={handleChange} />
                            }
                                label="Is Password Protected"
                                labelPlacement="end"
                            />
                        </div>

                        
                            {isPasswordProtected ? (
                                <TextField
                                    style={{margin:'10px'}}
                                    id="outlined-required"
                                    type={showPassword ? "text" : "password"}
                                    label="Password"
                                    value={password}
                                    variant="outlined"
                                    onChange={(e)=>{setPassword(e.target.value)}}
                                    InputProps={{ // <-- This is where the toggle button is added.
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <IconButton
                                              aria-label="toggle password visibility"
                                              onClick={handleClickShowPassword}
                                              onMouseDown={handleMouseDownPassword}
                                            >
                                              {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                          </InputAdornment>
                                        )
                                      }}
                                />
                            ) : ""}
                        

                        <Button variant="contained" color="primary" style={{margin:'10px'}} onClick={submitCreate}>
                        { cLoader ? "Creating...":   "Create Room"}
                        </Button>

                    </div>     
                </div>

                <div>
                <Snackbar 
                    open={open} 
                    autoHideDuration={3500} 
                    onClose={handleCloseError}
                    anchorOrigin={{vertical:'top', horizontal:'center'}}
                >
                    <Alert onClose={handleCloseError} severity="error">
                        {validationError}
                    </Alert>
                </Snackbar>
                </div>
            </div>
        </div>
    )
}

export default Create
